var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("swb-query-sort-area", {
        attrs: { config: _vm.queryConfig, queryHandler: _vm.queryHandler }
      }),
      _vm._v(" "),
      _vm.checkBox
        ? _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.msuList,
                    border: "",
                    "tooltip-effect": "dark"
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      type: "selection",
                      selectable: _vm.selectable,
                      width: "55"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "fileBrowseUrl",
                      label: "图片"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.fileBrowseUrl != null
                              ? _c("div", [
                                  _c("img", {
                                    staticClass: "wh100",
                                    attrs: { src: scope.row.fileBrowseUrl }
                                  })
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "服务名称",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "服务类型", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.type != null
                              ? _c("span", { attrs: { type: "success" } }, [
                                  _vm._v(
                                    _vm._s(_vm.workServcTypeMap[rows.row.type])
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "toDoorFee",
                      label: "上门费(元)",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.toDoorFee != null
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        rows.row.toDoorFee
                                          .toFixed(2)
                                          .replace(
                                            /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
                                            "$&,"
                                          )
                                      )
                                    )
                                  ])
                                ])
                              : _c("div", [_c("span", [_vm._v("0.00")])])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "参考人工费(元)", align: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.workHourFee != null
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        rows.row.workHourFee
                                          .toFixed(2)
                                          .replace(
                                            /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
                                            "$&,"
                                          )
                                      )
                                    )
                                  ])
                                ])
                              : _c("div", [_c("span", [_vm._v("0.00")])])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "参考价格(元)", align: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.generallFee != null
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        rows.row.generallFee
                                          .toFixed(2)
                                          .replace(
                                            /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
                                            "$&,"
                                          )
                                      )
                                    )
                                  ])
                                ])
                              : _c("div", [_c("span", [_vm._v("0.00")])])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "wrntPeriod",
                      label: "质保期(单位：天)",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "shelfState",
                      label: "状态",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.shelfState == 0
                              ? _c(
                                  "el-tag",
                                  {
                                    staticStyle: {
                                      "background-color": "transparent",
                                      border: "none"
                                    },
                                    attrs: {
                                      type: "danger",
                                      "close-transition": ""
                                    }
                                  },
                                  [_vm._v("未上架")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.shelfState == 1
                              ? _c(
                                  "el-tag",
                                  {
                                    staticStyle: {
                                      "background-color": "transparent",
                                      border: "none"
                                    },
                                    attrs: {
                                      type: "success",
                                      "close-transition": ""
                                    }
                                  },
                                  [_c("span", [_vm._v("已上架")])]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.shelfState == -1
                              ? _c(
                                  "el-tag",
                                  {
                                    staticStyle: {
                                      "background-color": "transparent",
                                      border: "none"
                                    },
                                    attrs: {
                                      type: "danger",
                                      "close-transition": ""
                                    }
                                  },
                                  [_c("span", [_vm._v("已下架")])]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.msuList,
                    border: "",
                    "highlight-current-row": ""
                  },
                  on: { "current-change": _vm.handleCurrentChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { width: "55" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "copy-radio",
                                class: {
                                  circle:
                                    _vm.checlMsuInfo != null &&
                                    _vm.checlMsuInfo.id == rows.row.id
                                }
                              },
                              [_c("div", { staticClass: "circle-dot" })]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "55",
                      align: "center",
                      prop: "fileBrowseUrl",
                      label: "图片"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.fileBrowseUrl != null
                              ? _c("div", [
                                  _c("img", {
                                    staticClass: "wh100",
                                    attrs: { src: scope.row.fileBrowseUrl }
                                  })
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "servcName",
                      label: "服务项目名称",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "服务名称",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "服务类型", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.type != null
                              ? _c("span", { attrs: { type: "success" } }, [
                                  _vm._v(
                                    _vm._s(_vm.workServcTypeMap[rows.row.type])
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "服务用途", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.comnOnlyFlag
                              ? _c("span", [_vm._v("常规服务")])
                              : _c("span", [_vm._v("维保服务")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      align: "right",
                      prop: "toDoorFee",
                      label: "上门费(元)",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "120",
                      align: "right",
                      prop: "workHourFee",
                      label: "参考人工费(元)",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      align: "right",
                      prop: "generallFee",
                      label: "服务费(元)",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      align: "right",
                      prop: "wrntPeriod",
                      label: "质保期(天)",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _vm.objectType != 2
                    ? _c("el-table-column", {
                        attrs: {
                          width: "100",
                          align: "center",
                          prop: "shelfState",
                          label: "状态",
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.shelfState == 0
                                  ? _c(
                                      "el-tag",
                                      {
                                        staticStyle: {
                                          "background-color": "transparent",
                                          border: "none"
                                        },
                                        attrs: {
                                          type: "danger",
                                          "close-transition": ""
                                        }
                                      },
                                      [_c("span", [_vm._v("未上架")])]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.shelfState == 1
                                  ? _c(
                                      "el-tag",
                                      {
                                        staticStyle: {
                                          "background-color": "transparent",
                                          border: "none"
                                        },
                                        attrs: {
                                          type: "success",
                                          "close-transition": ""
                                        }
                                      },
                                      [_c("span", [_vm._v("已上架")])]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.shelfState == -1
                                  ? _c(
                                      "el-tag",
                                      {
                                        staticStyle: {
                                          "background-color": "transparent",
                                          border: "none"
                                        },
                                        attrs: {
                                          type: "danger",
                                          "close-transition": ""
                                        }
                                      },
                                      [_c("span", [_vm._v("已下架")])]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block pagination-layout" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "page-size": _vm.pageSize,
              "page-sizes": _vm.pageSizes,
              "current-page": _vm.pageNumber,
              total: _vm.totalCount,
              layout: "total, sizes, prev, pager, next, jumper"
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.handleSizeChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58344b09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58344b09","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servc/MsuListForSelect.vue
// module id = 2367
// module chunks = 0